import * as React from "react";
import { createSvgIcon } from "../utils";

export const Remove = createSvgIcon(
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.037 12a.7.7 0 0 1 .7-.7h14a.7.7 0 1 1 0 1.4h-14a.7.7 0 0 1-.7-.7Z"
    />,
    "Remove",
);

export default Remove;
